// eslint-disable-next-line import/prefer-default-export
export const transformToArray = err => {
  const errors = [];
  const { error } = err.response.data;
  const { message } = error;
  const { fields } = error;
  if (!fields) return [{ value: message, key: null }];

  Object.keys(fields).map(key => {
    let newKey = key;

    // converte em camel case
    if (newKey.includes('.')) {
      const parts = newKey.split('.');
      newKey =
        parts[0] +
        parts
          .splice(1)
          .map(part => part[0].toUpperCase() + part.slice(1))
          .join('');
    }

    return errors.push({ key: newKey, value: fields[key][0] });
  });

  return errors;
};
